import Link from 'next/link';
// styles
import NeutralButton from "./NeutralButton";

const LinkButton = ({href, prefetch, ...custom}) => {
  return (
    <div css={{maxWidth: custom.maxWidth || '300px', width: '100%'}}>
      <Link href={href} prefetch={prefetch} passHref>
        <a>
          <NeutralButton
              {...custom}
          />
        </a>
      </Link>
    </div>
  )
}
export default LinkButton;